import { SvgIcon, SvgIconProps } from '@mui/material'

const PlayCircleOutlineSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18">
        <path
            fill="currentColor"
            d="M2 9a7 7 0 1 1 14 0A7 7 0 0 1 2 9zm7-8a8 8 0 1 0 0 16A8 8 0 0 0 9 1zM7.79 5.09A.5.5 0 0 0 7 5.5v7a.5.5 0 0 0 .79.41l5-3.5a.5.5 0 0 0 0-.82l-5-3.5zM11.63 9L8 11.54V6.46L11.63 9z"
        ></path>
    </svg>
)

const PlayCircleOutline: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{PlayCircleOutlineSvg}</SvgIcon>

export default PlayCircleOutline
